<template>
  <div class="app-content content ">
    <div class="content-overlay" />
    <div class="header-navbar-shadow" />
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <div class="row breadcrumbs-top">
            <div class="col-12">
              <h2 class="content-header-title mb-0">{{ award.id ? 'Edit' : 'New' }} honour & award<br>
              </h2>
              <BriefExplanation section="honoursAndAwards.header" />
            </div>
          </div>
        </div>
        <div class="content-header-right text-md-end col-md-3 col-12 d-md-block d-none">
          <div class="mb-1 breadcrumb-right">
            <a
              class="btn btn-icon btn-secondary"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Back to areas & groups list"
              @click="$router.push({name: 'researcher.honours-awards.index'})"
            ><i data-feather="chevron-left" /></a>
            <a
              v-if="loggedUser.roles.includes('super-admin')"
              class="btn btn-icon btn-flat-secondary"
              @click="$store.dispatch('modals/toggleRequestModal', 'HonourAward')"
            ><i data-feather="settings" /></a>
          </div>
        </div>
      </div>

      <div class="content-body content-body--senior-call">
        <div
          v-if="errors != ''"
          class="alert alert-danger mt-1 p-1"
        >
          {{ errors }}
        </div>
        <div class="row">
          <form
            id="edit-form"
            action=""
          >
            <div class="col-12">
              <SearchResearcher :item="award" />
              <div class="card">
                <div class="card-header">
                  <h3 class="cart-title">
                    <a data-action="collapse">Content</a>
                  </h3>
                  <div class="heading-elements">
                    <ul class="list-inline mb-0">
                      <li>
                        <a data-action="collapse"><i data-feather="chevron-down" /></a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="card-content collapse show">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="mb-1 form-group required">
                          <label
                            for=""
                            class="form-label"
                          >{{ labels['content.title'] }}</label>
                          <input
                            v-model="award.title"
                            class="form-control"
                            type="text"
                          >
                        </div>
                      </div>
                      <div class="col-sm-12">
                        <div class="mb-1 form-group required">
                          <label
                            for=""
                            class="form-label"
                          >{{ labels['content.description'] }}</label>
                          <quill-editor
                            v-model="award.description"
                          />
                        </div>
                      </div>
                      <hr>
                      <div class="col-sm-12">
                        <div class="mb-1 form-group required">
                          <label
                            for=""
                            class="form-label"
                          >{{ labels['content.year'] }}</label>
                          <date-picker
                            v-model="award.year"
                            format="Y"
                            type="year"
                            value-type="format"
                            class="w-100"
                          />
                        </div>
                      </div>
                      <div class="col-sm-12 mb-1">
                        <div class="form-check form-check-success form-switch d-flex align-items-center">
                          <input
                            id=""
                            v-model="award.memoir"
                            type="checkbox"
                            class="form-check-input"
                            name="currentPosition"
                          >
                          <label
                            class="form-check-label"
                            for=""
                          ><span class="ms-1">{{ labels['content.award_listed_in_memoir'] }} </span></label>
                        </div>
                      </div>
                      <hr>
                      <div class="col-sm-12">
                        <div class="mb-1 form-group">
                          <div class="form-check form-check-success form-switch d-flex align-items-center">
                            <input
                              id=""
                              v-model="award.published_web"
                              type="checkbox"
                              class="form-check-input"
                            >
                            <label
                              class="form-check-label"
                              for=""
                            ><small class="ms-1">{{ labels['content.active'] }} </small></label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <AddFile
                :id="6"
                :title="'Files'"
                :type="3"
                :files="award.files"
                @saveAnswer="saveFiles"
              />
            </div>
            <AttachedForm
              :type="'HonourAward'"
              :model-id="awardId"
            />
          </form>
        </div>

        <div class="page-actions">
          <button
            v-if="!sending"
            id="type-success"
            class="btn btn-success"
            @click="save"
          >
            <i data-feather="save" />
            <span class="ms-25 align-middle">Save and Exit</span>
          </button>
          <button
            v-else
            class="btn btn-outline-success"
            type="button"
            disabled=""
          >
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            />
            <span class="ms-25 align-middle">Saving...</span>
          </button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import AddFile from '../../admin/senior-call/components/AddFile.vue'
import SearchResearcher from '../../partials/components/SearchResearcher.vue'
import AttachedForm from '../../forms/partials/AttachedForm.vue'
import BriefExplanation from '../../partials/components/BriefExplanation.vue'

export default {
  components: {
    AddFile,
    SearchResearcher,
    DatePicker,
    AttachedForm,
    BriefExplanation,
  },
  data() {
    return {
      awardId: this.$route.params.id,
      sending: false,
      errors: '',
    }
  },
  computed: {
    ...mapGetters({
      award: 'awards/award',
      labels: 'sectionLabels/itemLabels',
      loggedUser: 'auth/admin',
      attached: 'requestForms/attached',
    }),
  },
  async mounted() {
    this.$store.dispatch('sectionLabels/fetchLabels', 'my_profile.honours_&_awards')
    if (this.awardId) {
      await this.$store.dispatch('awards/fetchAward', this.awardId)
    } else {
      await this.$store.dispatch('awards/cleanAward')
    }
  },
  methods: {
    async save() {
      this.sending = true
      this.award.attached_form = this.attached

      try {
        if (this.awardId) {
          await this.$store.dispatch('awards/update', { id: this.awardId, data: this.award })
        } else {
          await this.$store.dispatch('awards/create', this.award)
        }
        this.errors = ''
      } catch (e) {
        this.errors = e.response.data.message
      }

      if (this.errors === '' && this.award.id) {
        Vue.swal('The honour & awards has been saved correctly!', '', 'success').then(() => {
          this.$router.push({ name: 'researcher.honours-awards.index' })
        })
      } else {
        // Vue.swal
      }

      this.sending = false
    },
    saveFiles(files) {
      this.award.files_new = files.data
    },
  },

}
</script>
